import { DistributionJob, DistributionJobState } from '../../../models/distribution-doc-models';
import { Input, OnInit, Directive } from '@angular/core';
import { UpdateComponent } from '../../base/update.component';

@Directive()
export abstract class DistributionHeaderComponent<T extends DistributionJob> extends UpdateComponent
                                                                             implements OnInit {

    @Input()
    public bananaBox: T;

    get DistributionJobState() {
        return DistributionJobState;
    }

    get isCaseDistributionJob(): boolean {
        return !!this.bananaBox && !this.bananaBox.workflow_id;
    }

    protected constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
    }


    public abstract isValid(): boolean;

    public abstract validate(): boolean;
}
